<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col cols="12">
        <hr />
        <b-form-text id="password-help-block">
          <p>{{ $t("aNewPasswordNeedsToMeetTheFollowingRequirements") }}</p>
          <ul>
            <li>{{ $t("minimumLengthOf8Characters") }}</li>
            <li>{{ $t("atleastOneCapitalATmZ") }}</li>
            <li>{{ $t("atleastOneLowercaseATmZ") }}</li>
            <li>
              {{ $t("atleastOneNumber0Tm9") }}
            </li>
            <li>{{ $t("atleastOneSpecialCharacter") }}</li>
          </ul>
        </b-form-text>
      </b-col>
      <b-col cols="12">
        <b-alert variant="primary" :show="alert.length > 0">{{
          alert
        }}</b-alert>
      </b-col>
      <b-col md="6">
        <b-form-group
          id="serial-or-productnumber-label"
          :label="$t('password2')"
          label-for="password"
        >
          <b-form-input
            id="password"
            v-model="form.password"
            type="password"
            :state="passwordCriteria"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          id="serial-or-productnumber-label"
          :label="$t('passwordConfirmation')"
          label-for="passwordConfirmation"
        >
          <b-form-input
            id="passwordConfirmation"
            v-model="form.passwordConfirmation"
            type="password"
            :state="passwordValidty"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-button
          v-if="!processing"
          :disabled="disableForm"
          type="submit"
          class="btn btn-default mt-2"
          >{{ $t("submit4") }}</b-button
        >
        <b-button v-if="processing" class="mt-3" block disabled
          ><i class="fas fa-spinner fa-spin"></i
        ></b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BAlert,
  BRow,
  BCol,
} from "bootstrap-vue";
export default {
  components: {
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BRow,
    BCol,
    BAlert,
  },
  props: {
    userid: {
      required: true,
      type: String,
    },
    code: {
      required: true,
      type: String,
    },
  },
  data: function () {
    return {
      form: {
        password: "",
        passwordConfirmation: "",
      },
      disableForm: false,
      processing: false,
      alert: "",
    };
  },
  computed: {
    passwordCriteria: function () {
      let password = this.form.password;
      if (password != "") {
        if (password.length < 8) {
          return false;
        }

        if (!password.match(/[!@$%&]/)) return false;
        if (!password.match(/[0-9]/)) return false;
        if (!password.match(/[a-z]/)) return false;
        if (!password.match(/[A-Z]/)) return false;
        if (!/^([0-9a-zA-Z!@$%&]*)$/.exec(password)) return false;

        return true;
      }

      return null;
    },
    passwordValidty: function () {
      if (this.form.password.length === 0) return null;
      if (this.form.passwordConfirmation.length === 0) return null;
      if (this.form.passwordConfirmation !== this.form.password) return false;

      return true;
    },
  },
  methods: {
    submit: async function () {
      // eslint-disable-next-line no-undef
      const result = await State.updatePassword(
        null,
        this.userid,
        this.code,
        this.form.password,
        this.form.passwordConfirmation,
      );

      if (result.IsSucces) {
        this.alert = this.$t("passwordChanged");
        this.disableForm = true;
      } else {
        this.alert = this.$t("somethingWentWrong");
      }
    },
  },
};
</script>

<style></style>
